import React, { useEffect, useState } from "react";
import MUITable from "Components/UI/Tables/MUITable";
import { Link, useLoaderData } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import cutStrAtAndAddDots from "utils/cutStrAtAndAddDots";
import useTableOptions from "Hooks/useTableOptions";
import CommonChip from "Components/UI/Tables/CommonChip";
import LinkIcon from "@mui/icons-material/Link";

import {
  getDefaultServiceLabelById,
  getParseStatusLabelById,
  getClientTemplateLabelById,
  getSystemStatusLabelById,
} from "utils/labels";
import {
  getSystemStatusColorByLabel,
  getParseStatusColorByLabel,
} from "utils/colors";
import RefreshBtn from "Components/UI/Tables/RefreshBtn";
import { useClients } from "Context/Clients";

const createTableRows = (clients) => {
  return clients.map((client) => {
    return [
      client.Id,
      client.CNr,
      client.Name,
      client.OrgNo,
      client.Address,
      client.Email,
      client.VATRegistration,
      getDefaultServiceLabelById(client.DefaultService),
      getParseStatusLabelById(client.ParseStatus),
      cutStrAtAndAddDots(client.ParseMessage, 45),
      getSystemStatusLabelById(client.SystemStatus),
      client.CreateTime,
    ];
  });
};

export default function ClientsTable() {
  const { clients, fetchClients, hasFetchedAll } = useClients();
  const { handleColumnShow, isColDisplayed } =
    useTableOptions("ClientsMainTable");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!hasFetchedAll) {
      fetchClients();
    }
  }, []);

  useEffect(() => {
    const rows = createTableRows(clients);
    setRows(rows);
  }, [clients]);
  const columns = [
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: true,

        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "ID",
      options: {
        filter: false,
        display: isColDisplayed("ID"),
      },
    },
    {
      name: "Klientnummer",
      options: {
        filter: false,
        display: isColDisplayed("Klientnummer"),
      },
    },
    {
      name: "Namn",
      options: {
        filter: true,
        display: isColDisplayed("Namn"),
      },
    },
    {
      name: "Org.Nr",
      options: {
        filter: false,
        display: isColDisplayed("Org.Nr"),
      },
    },
    {
      name: "Adress",
      options: {
        filter: false,
        display: isColDisplayed("Adress"),
      },
    },
    {
      name: "Epost",
      options: {
        filter: false,
        display: isColDisplayed("Epost"),
      },
    },
    {
      name: "Momsregnummer",
      options: {
        filter: false,
        display: isColDisplayed("Momsregnummer"),
      },
    },
    {
      name: "Förvald tjänst",
      options: {
        filter: true,
        display: isColDisplayed("Förvald tjänst"),
      },
    },
    {
      name: "Kontrollstatus",
      options: {
        filter: true,
        display: isColDisplayed("Kontrollstatus"),
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getParseStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Kontrollmeddelande",
      options: {
        filter: false,
        display: isColDisplayed("Kontrollmeddelande"),
      },
    },
    {
      name: "Status",
      options: {
        filter: true,
        display: isColDisplayed("Status"),
        sort: true,
        filterList: ["Aktiv"],
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getSystemStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Skapad",
      options: {
        filter: false,
        display: isColDisplayed("Skapad"),
      },
    },
  ];

  const options = {
    selectableRows: "none",
    onViewColumnsChange: (changedColumn, action) => {
      handleColumnShow(changedColumn, action);
    },
    customToolbar: () => {
      return (
        <>
          <RefreshBtn />
        </>
      );
    },
    selectableRowsHideCheckboxes: true,
    filterType: "dropdown",
    responsive: "standard",
    downloadOptions: {
      separator: ";",
      filename: "all_clients.csv",
    },
    rowsPerPage: 30,
    rowsPerPageOptions: [10, 30, 100],
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <MUITable options={options} title={""} data={rows} columns={columns} />
  );
}
